<template>
    <div class="printOptionsComponent">
        <div class="formatContainer container">
            <div class="subcontainer">
                <div v-for="print_option in stock.print_options" v-if="print_option.code !='p_quantity'" v-show="parseInt(print_option.options.length) > 1">
                    <h4 class="h5">{{print_option.name}}</h4>
                    <div class="optionHolder"  >
                        <div v-for="option in print_option.options" :class="[{active: parseInt(option.isActive)},'dog_color','is_dog_tag','optionPlaceHolder','cmpt','page_option'+option.code+'_'+option.product_part]" @click="changeConfiguration(option)">
                            <a  href="javascript:void(0)">
                                <img :src="option.image_url" alt="image description" width="101" height="92">
                            </a>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props   : ['stock'],
        methods : {
            changeConfiguration ( option ) {
                this.stock.isReady = 0;
                $jQuery.printqLabelEditor.passChangesStock( option.code,option.parent,option.product_part );
                store.dispatch( 'setOptionActiveStock', {stock : this.stock, option : option} );
            },
            _O: function (o,defaults) {
                var d = $jQuery.extend(true, {}, d);
                return $jQuery.extend(true, defaults, o);
            },
        },
        computed : {
            getOptionClass ( option ) {
                return  option.code;
            },
            defaultEditorColors(){
                return window.defaultEditorColors;
            }
        }
    }
</script>
<style scoped="true">
.is_dog_tag img{
    display:block
}
</style>



// WEBPACK FOOTER //
// src/components/Printoptions/Printoptionsstock.vue